import React from 'react';
import { Event, MultiAppointmentResponse } from '../types';
import Utils from '@/utils/util';
import { useAuth } from '@/lib/auth';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
type RequestPaymentProps = {
  multiAppointmentDetails: MultiAppointmentResponse;
  totalAmount?: number;
};
export const MultiAppointmentPreview = ({
  multiAppointmentDetails,
  totalAmount,
}: RequestPaymentProps) => {
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');

  return (
    <div className="appointment-preview multi">
      <div className="left-section details">
        <p>{multiAppointmentDetails.list.length} services</p>
        <p>
          {multiAppointmentDetails.list.map((appointment, index) => (
            <>
              <span>{appointment.service.name} </span>
              {multiAppointmentDetails.list.length - 1 != index && (
                <span className="seperator">| </span>
              )}
            </>
          ))}{' '}
        </p>
      </div>
      <div className="right-section details">
        <p>
          {currency} {totalAmount}
        </p>
        <p>{multiAppointmentDetails.list.length} pets</p>
      </div>
    </div>
  );
};
